import { FilterData } from 'path-shared/models/filter-data';
import { SortDirection } from '@angular/material';

export class MotiusAnulacioFilter extends FilterData {
  id: number;
  descripcio: string;

  constructor(sortField: string, sortDir: SortDirection) {
    super(sortField, sortDir);
    this.id = 0;
    this.descripcio = '';

    this.labels['id'] = this.i18n('Id');
    this.labels['descripcio'] = this.i18n('Descripció');
  }
}
